import type { JSX, Ref } from 'react'
import type { Width } from './ProgressBar.h'

import { COLOR } from 'vars/color'
import { Corners, Height } from './ProgressBar.h'
import { Progress, Track } from './ProgressBar.styled'

export interface IProgressBarProps {
  ref?: Ref<HTMLDivElement>
  background?: COLOR
  color?: COLOR
  width?: Width
  height?: Height
  corners?: Corners
  progress?: number | null
}

export function ProgressBar({
  ref,
  background = COLOR.SURFACE_OPACITY_LIGHT_10,
  color = COLOR.ACCENT_SECONDARY,
  width,
  height = Height.SIZE_10,
  corners = Corners.CORNERS_10,
  progress = 0,
}: IProgressBarProps): JSX.Element | null {
  return progress ? (
    <Track
      ref={ref}
      width={width}
      background={background}
      height={height}
      corners={corners}
    >
      <Progress progress={progress} height={height} colorDefault={color} />
    </Track>
  ) : null
}
